export default __webpack_public_path__ + "static/media/how-to-buy.7f53cbb4.jpg";